/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { Currency } from 'common/types/format';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { UseWaterfallBreakpointsTableData } from '../../types/breakpoint-analysis.models';
import { parser, rowConfig } from '../common';

const useWaterfallBreakpointsTableData = ({ waterfallColumns, format }: UseWaterfallBreakpointsTableData) => {
  const [spreadsheet, setSpreadsheet] = useState<SpreadsheetConfig | null>(null);
  const { currency } = format;
  const { symbol: currencySymbol, code: currencyCode } = currency as Currency;

  const config = useMemo(() => rowConfig({ data: waterfallColumns, isCustomBreakpoint: false }), [waterfallColumns]);

  const tableTerms = useMemo(
    () => ({
      tableName: 'Calculated Breakpoints',
      tableSlug: 'calculated-breakpoints',
      columnName: 'Calculated Breakpoints',
    }),
    []
  );

  useEffect(() => {
    if (waterfallColumns && tableTerms) {
      const spreadsheetConfig = new SpreadsheetConfig({
        parser,
        rowConfig: config,
        name: 'WaterfallBreakPoint',
        columns: waterfallColumns,
        tableData: {
          currencySymbol,
          columns: waterfallColumns,
          isCustomBreakpointsTable: false,
        },
        currency: `${currencyCode} ${currencySymbol}`,
        tableTerms,
        showTotalColumn: false,
        showToolbar: false,
        showPreviousColsDivider: false,
        hasColTitle: true,
        allowConfirmAndDeleteColumn: false,
        currencyFormatter: false,
        unitsFormatter: false,
        format,
        allowCopyColumn: false,
        allowReorderColumns: false,
      } as SpreadsheetConfig);

      setSpreadsheet(spreadsheetConfig);
    }
  }, [waterfallColumns, tableTerms]);

  return {
    spreadsheet,
  };
};

export default useWaterfallBreakpointsTableData;
